import { Injectable } from '@angular/core';
import { LocalStorageService } from './storage/local-storage.service';
import {
  CanActivate,
  CanLoad,
  Router,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { EesDesService } from './ees-des.service';

@Injectable()
export class AuthGuardService implements CanActivate, CanLoad {
  constructor(
    private router: Router,
    private toasterService: ToasterService,
    private _localStorageService: LocalStorageService,
    public eesdesService:EesDesService
  ) {}
  urlList: any = [];
  arrayForSearch: any = [];

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let data: any = {};
    data = this.eesdesService.get('menus',localStorage.getItem('menus'))
      ? this.eesdesService.get('menus',localStorage.getItem('menus'))
      : {};
    const AutoLogout = localStorage.getItem('AutoLogout');
    const company_id = sessionStorage.getItem('company_id');
    if (AutoLogout == 'true' && (!company_id || company_id == undefined)) {
     
        window.location.href = window.location.origin + '/#/login';
        return false;
        
    }
    this.urlList = data ? data : [];
    if (
      this._localStorageService.getUserId() == undefined ||
      this._localStorageService.getUserId() == null
    ) {
      this.toasterService.pop(
        'warning',
        'Warning',
        'You are not able access this page! Login First'
      );
      // this.router.navigateByUrl('/login');
      window.localStorage.clear();
      window.location.href = window.location.origin + '/#/login';

      return false;
    }
    if (
      this._localStorageService.getEmpCompanyId() == 0 ||
      this._localStorageService.getEmpCompanyId() == null ||
      this._localStorageService.getEmpCompanyId() == undefined
    ) {
    } else {
      const currenturl = state.url ? state.url : '';
      let count = 0;
      if (this.urlList.length > 0) {
        for (const i of this.urlList) {
          if (i.aurl == currenturl) {
            count++;
          }
          if (i.submenu != undefined) {
            for (const j of i.submenu) {
              if (j.aurl == currenturl) {
                count++;
              }
            }
          }
        }
        if (count <= 0 && currenturl != '/dashboard') {
          this.toasterService.pop(
            'warning',
            'Warning',
            'you are not able access this page'
          );
          // this.router.navigateByUrl('/dashboard');
          window.localStorage.clear();
          window.location.href = window.location.origin + '/#/dashboard';
          return false;
        }
      }
    }

    return true;
  }

  canLoad(route: Route): boolean {
    let data: any = [];
    data = this.eesdesService.get('menus',localStorage.getItem('menus'))
      ? this.eesdesService.get('menus',localStorage.getItem('menus'))
      : [];
    const AutoLogout = localStorage.getItem('AutoLogout');
    const company_id = sessionStorage.getItem('company_id');

    if (AutoLogout == 'true' && (!company_id || company_id == undefined)) {
        
          window.location.href = window.location.origin + '/#/login';
          return false;
    }

    this.urlList = data ? data : [];
    if (
      this._localStorageService.getUserId() == undefined ||
      this._localStorageService.getUserId() == null
    ) {
      this.toasterService.pop(
        'warning',
        'Warning',
        'You are not able access this page! Login First'
      );
      window.localStorage.clear();
      window.location.href = window.location.origin + '/#/login';
      return false;
    }
    if (
      this._localStorageService.getEmpCompanyId() == 0 ||
      this._localStorageService.getEmpCompanyId() == null ||
      this._localStorageService.getEmpCompanyId() == undefined
    ) {
    } else {
      const currenturl = route.path;
      let count = 0;
      if (this.urlList.length > 0) {
        for (const i of this.urlList) {
          if (i.aurl == `/${currenturl}`) {
            count++;
          }
          if (i.submenu != undefined) {
            for (const j of i.submenu) {
              if (j.aurl === `/${currenturl}`) {
                count++;
              }
            }
          }
        }
        if (count <= 0 && currenturl != '/dashboard') {
          this.toasterService.pop(
            'warning',
            'Warning',
            'you are not able access this page'
          );
          window.localStorage.clear();
          window.location.href = window.location.origin + '/#/dashboard';
          return false;
        }
      }
    }
    return true;
  }

  prepareSearchList(data) {
    const menuList: any = [];
    for (const x of data) {
      if (x.aurl != '#') {
        menuList.push(x.aurl);
      }
      if (x.submenu) {
        for (const d of x.submenu) {
          if (d.aurl != '#') {
            menuList.push(d.aurl);
          }
        }
      }
    }
    return menuList;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1815813395/src/src/app/shared/services/auth-guard.service.ts